import { createSelector } from '@ngrx/store';
import { State } from './permission.reducer';

export const selectPermissionState = (state: any) => state.permissions;

export const selectPermissions = createSelector(
  selectPermissionState,
  (state: State) => state.data
);

export const selectAdminPermissions = createSelector(
  selectPermissionState,
  (state: State) => state.adminData
);

export const selectPermissionsLoading = createSelector(
  selectPermissionState,
  (state: State) => state.loading
);

export const selectAdminPermissionsLoading = createSelector(
  selectPermissionState,
  (state: State) => state.adminLoading
);

export const selectPermissionModalVisibility = createSelector(
  selectPermissionState,
  (state: State) => state.modalVisibility
);

export const selectPermissionsAndLoading = createSelector(
  selectPermissions,
  selectPermissionsLoading,
  (permissions, loading) => ({ permissions, loading })
);

export const selectAdminPermissionsAndLoading = createSelector(
  selectAdminPermissions,
  selectAdminPermissionsLoading,
  (permissions, loading) => ({ permissions, loading })
);
